import { render } from "./SingleviewArticle.vue?vue&type=template&id=cd80bbea&scoped=true"
import script from "./SingleviewArticle.vue?vue&type=script&lang=js"
export * from "./SingleviewArticle.vue?vue&type=script&lang=js"

import "./SingleviewArticle.vue?vue&type=style&index=0&id=cd80bbea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd80bbea"]])

export default __exports__